import React from "react";
import { Button } from "@ui/Button";
import { useAdminDeleteLogisticsPartnerMutation } from "@apollo/ops";
import { useDialog } from "@ui/Dialog";
import { ConfirmDialog } from "@components/Dialog/ConfirmDialog";
import { toast } from "@utilities/toast";
import { MessageSeverity } from "@shared/types/Severity";
import { getMessageToUserFromBackendError } from "@utilities/i18n";
import { useNavigate } from "@reach/router";
import { adminLogisticsPartnersPath } from "@routes";

type DeleteLogisticsPartnerButtonProps = {
  logisticsPartnerId: number;
};

export function DeleteLogisticsPartnerButton({
  logisticsPartnerId,
}: DeleteLogisticsPartnerButtonProps) {
  const [deleteLogisticsPartner] = useAdminDeleteLogisticsPartnerMutation();
  const dialog = useDialog();
  const navigate = useNavigate();

  const onConfirm = async () => {
    try {
      const result = await deleteLogisticsPartner({
        variables: {
          id: logisticsPartnerId,
        },
      });

      if (result.data) {
        toast.current?.show({
          severity: MessageSeverity.success,
          summary: "",
          detail: `Successfully deleted ${result.data.deleteLogisticsPartner.name}`,
        });
        navigate(adminLogisticsPartnersPath);
      }
    } catch (error) {
      toast.current?.show({
        severity: MessageSeverity.error,
        summary: getMessageToUserFromBackendError(error),
      });
    }
  };

  return (
    <>
      <Button destructive kind="secondary" onClick={dialog.open} size="sm">
        Delete
      </Button>
      <ConfirmDialog
        title="Are you sure you want to delete this logistics partner?"
        description="WARNING: Deleting this logistics partner is non-reversible"
        onConfirm={onConfirm}
        confirmText="Yes, delete this logistics partner"
        dialog={dialog}
      />
    </>
  );
}
